import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Toast, Notify, Dialog } from 'vant'
Vue.prototype.$toast = Toast
Vue.prototype.$notify = Notify
Vue.prototype.$dialog = Dialog
Vue.use(Vant)
